import React, { ReactElement } from 'react';
import { Box } from '@mui/material';

const DeletedBadge = (): ReactElement => {
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-block',
        px: 1,
        py: 0.25,
        borderRadius: '4px',
        backgroundColor: '#e0e0e0',
        color: '#757575',
        fontSize: '0.7rem',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        flexShrink: 0,
      }}
    >
      削除済み
    </Box>
  );
};

export default DeletedBadge;
